import { useEffect } from "react";
import { useRouter } from "@tanstack/react-router";
import { captureOnLanding } from "@/lib/meta-attribution";

const PIXEL_ID = "1447145560492223";

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & { callMethod?: unknown; queue?: unknown[] };
    _fbq?: unknown;
  }
}

export function MetaPixel() {
  const router = useRouter();

  useEffect(() => {
    if (typeof window === "undefined") return;
    // First-touch campaign attribution, persisted ~30 days for every form.
    captureOnLanding();

    const ric =
      (window as unknown as { requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number })
        .requestIdleCallback;
    const schedule = (cb: () => void) =>
      typeof ric === "function" ? ric(cb, { timeout: 2000 }) : window.setTimeout(cb, 2000);

    schedule(() => {
      if (!window.fbq) {
        (function (f: any, b: Document, e: string, v: string) {
          if (f.fbq) return;
          const n: any = (f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
          });
          if (!f._fbq) f._fbq = n;
          n.push = n;
          n.loaded = true;
          n.version = "2.0";
          n.queue = [];
          const t = b.createElement(e) as HTMLScriptElement;
          t.async = true;
          t.src = v;
          const s = b.getElementsByTagName(e)[0];
          s.parentNode?.insertBefore(t, s);
        })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");

        (window.fbq as any)?.("init", PIXEL_ID);
        (window.fbq as any)?.("track", "PageView");
      }
    });

    const unsub = router.subscribe("onResolved", () => {
      (window.fbq as any)?.("track", "PageView");
    });
    return () => unsub();
  }, [router]);

  return (
    <noscript>
      <img
        height="1"
        width="1"
        style={{ display: "none" }}
        alt=""
        src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`}
      />
    </noscript>
  );
}
